'use es6';

import PortalIdParser from 'PortalIdParser';
import { createClient } from 'laboratory-lib';
export const treatmentsClient = createClient({
  ceid: PortalIdParser.get(),
  quickFetchLabel: 'experiment-treatments',
  treatments: {},
  timeout: 3000
});
export const resolveTreatments = callback => {
  treatmentsClient.resolve(callback);
};